import React, { useContext } from 'react';
import WorkspaceContext from '../Context/WorkspaceContext';
import { useDispatch } from 'react-redux';
import { serviceActions } from '../../state/modules/service';
import { AlertType } from '../../graphql/schema/p4types';
import { useGridToolbarItemStyles } from './gridToolbarStyles';
import { useP4ToastController } from '../../views/system/NotificationsArea';

type GridToolbarWorkspaceRefreshButtonProps = {
  onClick?: () => void;
};

/**
 * A simple icon button to refresh the current workspace data, for use in a workspace toolbar.
 */
const GridToolbarWorkspaceRefreshButton = ({ onClick }: GridToolbarWorkspaceRefreshButtonProps) => {
  const workspaceContext = useContext(WorkspaceContext);
  const { dispatchSimpleToast } = useP4ToastController();

  const styles = useGridToolbarItemStyles();

  return (
    <div className={styles.switchView} style={{ paddingRight: '7px' }}>
      <a
        className={styles.switchViewLink}
        data-testid="refresh-workspace"
        onClick={() =>
          workspaceContext.reloadData().then(() => {
            dispatchSimpleToast('Workspace refresh', 'Workspace refresh completed', AlertType.Success);
            onClick?.();
          })
        }
      >
        <i className="icon">refresh</i>
      </a>
    </div>
  );
};

export default GridToolbarWorkspaceRefreshButton;
